/**
 * Centralized Google Analytics 4 event tracking utility.
 * GA is loaded globally via gtag.js in public/index.html.
 */

declare function gtag(...args: unknown[]): void;

export const trackEvent = (
  eventName: string,
  params?: Record<string, unknown>
): void => {
  if (typeof gtag === "function") {
    gtag("event", eventName, params ?? {});
  }
};

// ─── Event Name Constants ────────────────────────────────────────────────────

export const GA_EVENTS = {
  // Navigation
  PAGE_VIEW_HOME: "page_view_home",
  PAGE_VIEW_APP: "page_view_app",
  CLICK_START_DESIGNING: "click_start_designing",

  // Canvas
  BLOCK_ADDED: "block_added",
  BLOCK_DELETED: "block_deleted",
  CONNECTION_ADDED: "connection_added",
  CONNECTION_DELETED: "connection_deleted",

  // Game controls
  GAME_STARTED: "game_started",
  GAME_PAUSED: "game_paused",
  GAME_RESUMED: "game_resumed",

  // IOPS Config Modal
  IOPS_MODAL_OPENED: "iops_modal_opened",
  IOPS_CONFIG_SAVED: "iops_config_saved",
  TRAFFIC_PATTERN_CHANGED: "traffic_pattern_changed",

  // Scoreboard actions
  DESIGN_SAVED: "design_saved",
  DESIGN_RESTORED: "design_restored",
  DESIGN_DELETED: "design_deleted",
  CANVAS_RESET: "canvas_reset",

  // IOPS modal route and content actions
  CONTENT_TYPE_ADDED: "content_type_added",
  CONTENT_TYPE_REMOVED: "content_type_removed",
  ROUTE_ADDED: "route_added",
  ROUTE_REMOVED: "route_removed",
  ROUTE_PATH_RENAMED: "route_path_renamed",
} as const;
